/**
 * Where the crop box sits on the original image. The preview image is zoomed
 * with a CSS transform around its centre, which the crop box (drawn over the
 * unzoomed layout box) knows nothing about, so undo the zoom here: a point p
 * on screen shows image point (p - centre) / zoom + centre.
 */
export function cropToImageRect(
  crop: { x: number; y: number; width: number; height: number },
  layout: { width: number; height: number },
  zoom: number,
) {
  const cx = layout.width / 2;
  const cy = layout.height / 2;
  return {
    x: (crop.x - cx) / zoom + cx,
    y: (crop.y - cy) / zoom + cy,
    width: crop.width / zoom,
    height: crop.height / zoom,
  };
}
